import React, { useEffect, useState } from 'react';
import themeConfig from '@configs/themeConfig';

import { ChevronDown, Rss } from 'react-feather';

import { getUserData } from '../../../../utility/Utils';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { isMobile } from 'react-device-detect';
import UserDropdown from '../UserDropdown';
import { TiTicket } from 'react-icons/ti';
import Avatar from '@components/avatar';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

export default function TopMobileNav({scrolling}) {
  const userData = getUserData();
  const location = window.location.href;
  const userLocation = JSON.parse(localStorage.getItem('location'));

  const [shortName, setShortName] = useState('');
  const [activeMenu, setActiveMenu] = useState('dashboard');
  const [selectedLogo, setSelectedLogo] = useState(themeConfig.app.appLogoImage);
  const [selectedLocation, setSelectedLocation] = useState(themeConfig.app.appName);

  const handleChangeLocation = (loc) => {
    localStorage.setItem('location', JSON.stringify(loc));
    window.location.href = '/community/home';
  };

  useEffect(() => {
    if (userData) {
      if (userData?.fullName) {
        const nameOrArr = String(userData?.fullName).split(' ');
        const firstPart = nameOrArr.length > 0 ? nameOrArr[0] : '';
        const lastPart = nameOrArr.length > 1 ? nameOrArr[1] : '';
        setShortName(
          `${firstPart[0].toUpperCase()} ${lastPart[0] ? lastPart[0].toUpperCase() : ''}`
        );
      }
    }
  }, [userData]);
  useEffect(() => {
    if (location) {
      const locs = location.split('/');
      const loc = locs[locs.length - 1];
      setActiveMenu(loc);
    }
  }, [location]);
  useEffect(() => {
    if (userLocation && userLocation !== null) {
      if (userLocation?.logo) {
        setSelectedLogo(userLocation?.logo);
        setSelectedLocation(userLocation?.organizationName);
      }
    }
  }, [userLocation]);

  return (
    <div className={
              isMobile && scrolling
                ? 'client-community-navbar client-community-sticky px-1 py-50'
                : 'position-fixed w-100 bg-white py-50 px-1'
            }
            id="client-community-navbar" style={{ zIndex: '997' }}>
      <div className={`d-flex justify-content-between`}>
        <div className="my-auto w-100 mt-50 mb-50">
          <div className="d-flex justify-content-between align-items-center">
            <div>
            <div className="my-auto">
              <div className="d-flex">
                <Avatar img={selectedLogo} />
                <h5 className="brand-text my-auto ms-1">{selectedLocation}</h5>
                <UncontrolledDropdown className="my-auto">
                  <DropdownToggle tag={'span'} className="cursor-pointer">
                    <ChevronDown />
                  </DropdownToggle>
                  <DropdownMenu>
                    {userData?.roles?.map((x, idx) => {
                      return (
                        <DropdownItem
                          className="w-100"
                          key={idx}
                          onClick={() => handleChangeLocation(x)}
                        >
                          {x?.assignerCompanyName}
                        </DropdownItem>
                      );
                    })}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </div>
            </div>
            <div className="d-flex justify-content-end align-items-center">
              <UserDropdown userData={userData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
